import {FinancingCellCoordinates} from '../types/FinancingCellCoordinates';

/** Identity of a matrix cell, used to compare and deduplicate coordinates. */
export function getFinancingCellKey(coordinates: FinancingCellCoordinates) {
  return `${coordinates.term}:${coordinates.downPayment}:${coordinates.balloonPayment ?? 'none'}`;
}
